import { KeyValueModel } from "model";
import { EnumIndIcms } from "model/enums/enum-ind-icms";

export const IndIcmsMock: KeyValueModel[] = [
    new KeyValueModel(EnumIndIcms.Normal, 'Normal'),
    new KeyValueModel(EnumIndIcms.Destacado, 'Destacado'),
]